export enum StorageKeys {
  AccessToken = "ayol-access-token",
  TokenExpTime = "ayol-token-exp-time"
}
